module.exports = __webpack_public_path__ + "img/pocket_waist_seam.54fd40fb.png";